import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import DatePicker from "vue2-datepicker";
import VueLazyload from "vue-lazyload";
import * as VueGoogleMaps from "vue2-google-maps";
import VueImg from "v-img";
import "sweetalert2/dist/sweetalert2.min.css";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import firebase from 'firebase'

require("@/assets/styles/style.scss");
require("vue-multiselect/dist/vue-multiselect.min.css");
require("vue2-datepicker/index.css");
require("vue-image-lightbox/dist/vue-image-lightbox.min.css");
Vue.use(VueLazyload);
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(DatePicker);
Vue.use(VueImg);
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyBD8Hv87UGA_jtKdY-VImDcbPXRlb_Y4qw",
    libraries: "places",
    region: "TH",
    language: "th",
  },
  installComponents: true,
});
Vue.config.productionTip = false;

const config = {
  apiKey: 'AIzaSyCpK4brMbohiq0kfN9LwTJF7u9hvr2somg',
  authDomain: 'bedobio-db8f5.firebaseapp.com',
  projectId: 'bedobio-db8f5',
  storageBucket: '503903165801',
  messagingSenderId: '503903165801',
  appId: '1:503903165801:web:4d382693f2f2774f'
};

firebase.initializeApp(config);

firebase.auth().onAuthStateChanged(() => {
  new Vue({
    router,
    store,
    render: (h) => h(App),
  }).$mount("#app");
});
